import React from "react";

import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import { useAppContext } from "@state/hooks/shared";
import { getCurrentCulture } from "@utils";
import { observer } from "mobx-react";

export default observer(function DepositTabSwitcher() {
	const { t } = useTranslation("payment");
	const { culture } = useAppContext();

	return (
		<div className="card--primary__tabs u-padd--x--reset">
			<nav className="tabs--primary">
				<NavLink
					className="tabs--primary__item"
					activeClassName="is-active"
					replace={true}
					to={`/${culture}/deposit`}
					isActive={(match, location) => {
						return (
							location.pathname ==
							`/${getCurrentCulture()}/deposit`
						);
					}}
				>
					{t<string>("DEPOSIT.NEW_DEPOSIT")}
				</NavLink>
				<NavLink
					to={`/${culture}/deposit/history`}
					className="tabs--primary__item"
					replace={true}
					activeClassName="is-active"
					isActive={(match, location) => {
						return (
							location.pathname ==
							`/${getCurrentCulture()}/deposit/history`
						);
					}}
				>
					{t<string>("DEPOSIT.MY_DEPOSITS")}
				</NavLink>
			</nav>
		</div>
	);
});
